import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import LogIn from '../AccountManagement/LogIn';
import LogOut from '../AccountManagement/LogOut';
import UserRegistration from '../AccountManagement/RegisterUser';
import PasswordReset from '../PasswordReset/index';
import Reporting from '../Reporting/index';
import ReportView from '../Reporting/components/ReportView';
import Venue from '../Venue/index';
import VenueEdit from '../VenueEdit/index';
import VenuePhotos from '../VenuePhotos/index';
import Submissions from '../Submissions/index';
import Submission from '../Submission/index';
import ProtectedRoute from './ProtectedRoute';
import Performance from '../Performance';
import Profile from '../Profile';
import Users from "../Users";
import AcceptVenueInvitation from "../User/AcceptVenueInvitation";
import Subscriptions from "../Subscriptions";
import NewVenueWorkflow from '../AccountManagement/NewVenueWorkflow';
import RegisterUser from '../AccountManagement/RegisterUser';

// const Pages = () => (
//   <Switch>
//     <Route path="/pages/one" component={ExamplePageOne} />
//   </Switch>
// );

const venueId = localStorage.getItem('activeVenueId');

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
        {/*<Route path="/pages" component={Pages} />*/}
        <Route path="/reporting" component={Reporting} />
        <Route path="/reportView/:reportId" component={ReportView} />
        <Route exact path="/v/:venueId/submissions" component={Submissions} />

        <Route path="/profile" component={Profile} />
        <Route path="/v/:venueId/s/:submissionId" component={Submission} />
        <Route exact path="/v/:venueId" component={Venue} />
        <Route exact path="/v/:venueId/ml" component={VenuePhotos} />
        <Route path="/performance/:venueId" component={Performance} />
        <Route path="/edit/:venueId" component={VenueEdit} />
        
        <Route path="/v/:venueId/usrs" component={Users} />
        <Route path="/users/:venueId" component={Users} />
        <Route path="/subscriptions/:venueId" component={Subscriptions} />

        <Route path="/invitations/:id/:token" component={AcceptVenueInvitation} />
    </div>
  </div>
);

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/" component={LogIn} />
        <Route exact path="/login" component={LogIn} />
        <Route exact path="/newVenue" component={NewVenueWorkflow} />
        <Route exact path="/register" component={RegisterUser} />
        <Route exact path="/passwordReset/:token" component={PasswordReset} />
        <Route exact path="/logout" component={LogOut} />
        <ProtectedRoute path="/" component={wrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
